import { action, computed } from 'mobx'
import ListStore from '../../../shared-lib/stores/ListStore'
import ExternalTreatmentModel from './ExternalTreatmentModel'
import { scopeData } from '../../lib/scopeData'

export type $ExternalTreatmentStore = ExternalTreatmentStore

export default class ExternalTreatmentStore extends ListStore<ExternalTreatmentModel> {
  fetchMethodName = 'externalTreatments'
  ModelClass = ExternalTreatmentModel

  @computed get scopedItems() {
    const dataScopeId = this.rootStore.authStore.dataScopeId
    if (!dataScopeId) return this.items
    return scopeData(this.items, dataScopeId, 'ownerId')
  }

  @action.bound async updateTreatmentPricing_api(pricing: MutationUpdateTreatmentPricingArgs): Promise<boolean> {
    try {
      const { updateTreatmentPricing } = await this.rootStore.communication.requester.updateTreatmentPricing(pricing)
      this.mergeData(updateTreatmentPricing)
      return true
    } catch (e) {
      return false
    }
  }

  @computed get ownItems() {
    const ownId = this.rootStore.userStore.data._id
    return scopeData(this.items, ownId, 'ownerId')
  }
}